<template>
  <div class="location-form">
    <KycDropdown
      title="Location"
      subTitle="Fill in your address"
      :status="orgDetails.tokens?.length ? true : false"
      :edit="''"
      @active-dropdown="setDropdownStatus"
    >
      <template v-slot:content>
        <form @submit.prevent="uploadAddress" class="form-content">
          <div class="form-grid">
            <div class="form-group full-width">
              <TextAreaInput
                placeHolder="Enter your address"
                label="Address"
                name="address"
                id="address"
                :text="addressPayload?.address"
                :showLabel="true"
                :maxlength="200"
                :rows="4"
                @set="setAddress"
                @valid="addressValid"
              />
            </div>
            <div class="form-group">
              <SelectInput
                label="Country"
                name="country"
                id="country"
                defaltOption="Select country"
                :showLabel="true"
                :option="addressPayload?.country"
                :list="countryList"
                @set="setCountry"
              />
            </div>
            <div class="form-group">
              <SelectInput
                label="State"
                name="state"
                id="state"
                defaltOption="Select state"
                :showLabel="true"
                :option="addressPayload?.state"
                :list="stateList"
                @set="setState"
              />
            </div>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary" :disabled="addressLoading">
              <span v-if="addressLoading" class="btn-loader"></span>
              {{ $route.name === 'EsopDetails' ? 'Save Changes' : 'Continue' }}
            </button>
          </div>
        </form>
      </template>
    </KycDropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import KycDropdown from "@/components/general/KycDropdown.vue";
import TextAreaInput from "@/components/general/TextAreaInput.vue";
import SelectInput from "@/components/general/SelectInput.vue";
import countryCode from "@/utils/json/countryCode.json";
import countryRegionData from "@/utils/js/countryRegionData.js";
import Btn from "@/components/general/BtnComponent.vue";

export default {
  name: "TokenDetailAddressForm",

  components: {
    KycDropdown,
    TextAreaInput,
    SelectInput,
    Btn,
  },

  data() {
    return {
      addressLoading: false,
      validInput: {
        address: false,
      },
      countryCode,
      countryRegionData,
      countryList: [],
      stateList: [],
      addressPayload: {
        address: "",
        country: "",
        state: "",
      },
    };
  },

  computed: {
    ...mapState({
      orgDetails: (state) => state.organisationModule.organisationDetails,
      assetDetails: (state) => state.assetModule.assetDetails,
    }),
  },

  mounted() {
    this.formatCountryCode();
    this.setAddressFromOrgDetails();
  },

  methods: {
    ...mapActions("assetModule", ["getAsset", "updateAsset"]),
    ...mapActions(["showToast"]),

    setDropdownStatus(title) {
      this.$emit("dropdown-title", title);
    },

    async uploadAddress() {
      if (!this.validInput.address) {
        return this.showToast({
          description: "Please fill all input field correctly",
          display: true,
          type: "error",
        });
      }
      this.addressLoading = true;
      const payload = {
        about: this.assetDetails.about,
        name: this.assetDetails.name,
        type: this.assetDetails.type,
        ...this.addressPayload,
      };
      payload.country = payload.country.split("(")[1].split(")")[0];
      const response = await this.updateAsset({
        data: payload,
        id: this.$route.query.asset
          ? this.$route.query.asset
          : this.assetDetails._id,
      });
      if (response) this.$emit("dropdown-title", "Founder’s Information");
      this.addressLoading = false;
    },

    setAddress(address) {
      this.addressPayload.address = address;
    },

    setCountry(country) {
      if (!country) return;
      if (!country?.includes(" ")) {
        this.countryCode.countries.map((singleCountry) => {
          if (singleCountry.name === country || singleCountry.code === country)
            this.addressPayload.country = `${singleCountry.name} ${singleCountry.flag}  - (${singleCountry.code})`;
        });
        this.getStates(country);
        return;
      }
      this.addressPayload.country = country;
      this.getStates(country);
    },

    setState(state) {
      this.addressPayload.state = state;
    },

    addressValid(valid) {
      this.validInput.address = valid;
    },

    formatCountryCode() {
      this.countryList = this.countryCode.countries.map((country) => {
        return `${country.name} ${country.flag}  - (${country.code})`;
      });
    },

    getStates(country) {
      this.countryRegionData.map((countryData) => {
        if (country.includes(countryData.countryName)) {
          this.stateList = countryData.regions.map((state) => {
            return state.name;
          });
        }
      });
    },

    setAddressFromOrgDetails() {
      if (this.orgDetails.officeAddress) {
        this.addressPayload.address = this.orgDetails?.officeAddress;
        this.addressPayload.country = this.orgDetails?.country;
        this.addressPayload.state = this.orgDetails?.state;
        this.validInput = {
          address: true,
        };
        // if (this.orgDetails.asset) this.uploadAddress();
      }
    },

    updateTokenInfo() {
      if (!this.assetDetails?.address) {
        this.setAddressFromOrgDetails();
        return;
      }
      this.addressPayload.address = this.assetDetails?.address;
      this.addressPayload.country = this.assetDetails?.country;
      this.addressPayload.state = this.assetDetails?.state;
    },
  },

  watch: {
    assetDetails(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateTokenInfo();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.location-form {
  .form-content {
    padding: 8px 0;
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .form-group {
    display: flex;
    flex-direction: column;

    &.full-width {
      grid-column: 1 / -1;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
    border-top: 1px solid #E2E8F0;
    margin-top: 8px;
  }

  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 44px;
    padding: 0 24px;
    background: #4D84FF;
    border: none;
    border-radius: 8px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: #3A6FE8;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .btn-loader {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
